export default {
  state: {
    filter: {
      title: undefined,
      message: undefined,
      created_start: undefined,
      created_end: undefined,
      status: undefined,
    },
    manuals: [],
  },
  getters: {},
  mutations: {
    APPLY_FILTER: (state: any, payload: any) => (state.filter = payload),
  },
  actions: {
    applyFilter: (context: any, payload: any) => context.commit("APPLY_FILTER", payload),
  },
};
